module.exports = __webpack_public_path__ + "static/media/hamburger-icon-ufo.0bcadcd4.svg";